<template>
    <CostableTableRow
        class="hover:bg-initial larger-font bolder-font"
        :is-heading-row="true"
        heading-class="text-right"
    >

        <template v-slot:heading>
            {{ getGroupName }}
        </template>

        <template v-slot:totalCost>
            <span
                v-b-tooltip.hover.top.d50
                title="Cost"
            >
                {{ formatCurrency(group.totals.cost) }}
            </span>
        </template>

        <template v-slot:totalPrice>
            <span
                v-b-tooltip.hover.top.d50
                title="Price"
            >
                {{ formatCurrency(group.totals.price) }}
            </span>
        </template>

        <template v-slot:markup>
            <span
                v-b-tooltip.hover.top.d50
                title="Markup"
            >
                {{ formatCurrency(group.totals.markup) }}
            </span>
        </template>

        <template v-slot:margin>
            <span
                v-b-tooltip.hover.top.d50
                title="Margin"
            >
                {{ formatPercentage(group.totals.margin) }}
            </span>
        </template>

        <template v-slot:commissionDue>
            <span
                v-b-tooltip.hover.top.d50
                title="Commission Due"
            >
                {{ formatCurrency(group.totals.commission_due) }}
            </span>
        </template>

        <template v-slot:totalProfit>
            <span
                v-b-tooltip.hover.top.d50
                title="Total Profit"
            >
                {{ formatCurrency(group.totals.profit) }}
            </span>
        </template>
    </CostableTableRow>
</template>

<script>
import { formatCurrency, formatPercentage } from '@/utils/helpers';
import CostableTableRow from '@/modules/costable/_components/CostableTableRow';

export default {
    components: { CostableTableRow },
    props: {
        group: {
            type: Object,
            required: true,
        },
    },

    computed: {
        getGroupName() {
            return this.group.id ? `${this.group.name} Totals:` : 'Other Costs Totals:';
        },
    },

    methods: {
        formatCurrency,
        formatPercentage,
    },

};
</script>

<style lang="scss" scoped>
.larger-font {
    font-size: 14px;
}
.bolder-font {
    font-weight: 600;
}
</style>
